import { useRouter } from 'next/router';
export var useSpotSwapRouter = function useSpotSwapRouter() {
  var _useRouter = useRouter(),
      route = _useRouter.route,
      asPath = _useRouter.asPath;

  return asPath === '/instant' || /^\/exchange/g.test(route);
};